import {gql} from '@apollo/client/core';


export const PriceTableFragment = gql`
  fragment priceTable on PriceTable {
    id
    pricings {
      id
      amountIncVat
      maxQty
      minQty
      currencyCode
      discount {
        id
        to
        from
        amountExVat
        amountIncVat
      }
    }
  }
`;
